function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useCallback } from 'react';
import { classnames } from '@bydesign-ui/utils';
import { useRefCallback } from '@bydesign-ui/hooks';
import { usePrefixCls } from '@byte-design/config';
import { DoubleLeft, DoubleRight } from '../../common/icons';
export function Aside(props) {
  var className = props.className,
      _props$style = props.style,
      style = _props$style === void 0 ? {} : _props$style,
      _props$width = props.width,
      width = _props$width === void 0 ? 200 : _props$width,
      _props$trigger = props.trigger,
      trigger = _props$trigger === void 0 ? null : _props$trigger,
      _props$collapseWidth = props.collapseWidth,
      collapseWidth = _props$collapseWidth === void 0 ? 64 : _props$collapseWidth,
      _props$collapse = props.collapse,
      collapse = _props$collapse === void 0 ? false : _props$collapse,
      _props$collapsible = props.collapsible,
      collapsible = _props$collapsible === void 0 ? true : _props$collapsible,
      onCollapse = props.onCollapse,
      children = props.children,
      theme = props.theme,
      rest = _objectWithoutProperties(props, ["className", "style", "width", "trigger", "collapseWidth", "collapse", "collapsible", "onCollapse", "children", "theme"]);

  var collapseType = collapse ? 'collapse' : 'uncollapse';
  var onCollapseCallback = useRefCallback(onCollapse);
  var handleTrigger = useCallback(function () {
    if (!collapsible) {
      return;
    }

    onCollapseCallback(!collapse);
  }, [collapsible, collapse]);
  var cls = classnames(usePrefixCls('layout-aside', _defineProperty({}, theme !== null && theme !== void 0 ? theme : '', !!theme)), className);
  var contentCls = classnames(usePrefixCls('layout-aside-content', _defineProperty({}, collapseType, true)));
  var triggerCls = classnames(usePrefixCls('layout-aside-trigger', _defineProperty({}, collapseType, true)), usePrefixCls("layout-aside-trigger-".concat(trigger)));
  var widthStyle = {
    width: collapse ? collapseWidth : width
  };
  var realStyle = Object.assign({
    flexBasis: collapse ? collapseWidth : width
  }, style);

  var renderTrigger = function renderTrigger() {
    if (trigger === null) {
      return null;
    }

    var triggerIcon = collapse ? React.createElement(DoubleRight, null) : React.createElement(DoubleLeft, null);
    return React.createElement("div", {
      className: triggerCls,
      style: widthStyle,
      onClick: handleTrigger
    }, triggerIcon);
  };

  return React.createElement("aside", Object.assign({
    className: cls,
    style: realStyle
  }, rest), trigger === 'top' && renderTrigger(), React.createElement("div", {
    className: contentCls,
    style: widthStyle
  }, children), trigger === 'bottom' && renderTrigger());
}